<template>
  <v-card>
  
    <v-container fluid>
      <v-layout column>
        <o-base-justify-text v-if="!contrato">
          <span v-html="getTexto('kyc.simplificada', reserva.codigoPromocion)"/>
        </o-base-justify-text>
        <o-base-justify-text v-else-if="contrato">
          <span v-html="getTexto('contrato.simplificada', reserva.codigoPromocion)"/>
        </o-base-justify-text>
        
      </v-layout>
      <div v-if="getActual.modalidadFirma != 1">
        <v-layout justify-center mb-3>
          <v-card style="width: 50%">
          <v-container fluid>
            <label v-if="reserva.estadoKyc.codigoEstadoKyc < 3"
              class="theme--light v-label"
            >
              {{$t('reservaSimplificada.debeRellenarKyc')}}
            </label>
            <v-layout justify-space-between align-center >
              <h1 v-if="!contrato" class="primary--text">{{$t('reservaSimplificada.firmaContratoKYC')}}</h1>
              <h1 v-else class="primary--text">{{$t('mixins.reserva.contrato')}}</h1>
              <div>
                <v-layout>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                      v-on="on"
                        large :class="(contrato && reserva.contrato != null && reserva.contrato.documentoSinFirmar) || (!contrato && reserva.contratoKyc != null && reserva.contratoKyc.documentoSinFirmar) ? 'green' : 'primary'"
                        icon
                        :disabled="reserva.estadoSincronizacion != null || generando || reserva.estadoKyc.codigoEstadoKyc == 1 || (!contrato && reserva.contratoKyc && reserva.contratoKyc.documentoSinFirmar != null) || (contrato && reserva.contrato && reserva.contrato.documentoSinFirmar != null)"
                        :loading="generando"
                        @click="generarContrato()"
                      >
                      <v-icon style="color: white !important"  >mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>{{!contrato ? $t('reservaSimplificada.generarContratoKYC'): $t('reservaSimplificada.generarContrato') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!contrato">
                    <template v-if="!contrato" v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        @click.stop
                        :loading="generando"
                        :disabled="!reserva.contratoKyc"
                        :href="reserva.contratoKyc && reserva.contratoKyc.documentoSinFirmar ? $contrato(reserva.contratoKyc.documentoSinFirmar.documento.id, true) : ''"
                        target="_blank"
                      >
                      <v-icon   >mdi-eye </v-icon>
                        
                      </v-btn>               
                    </template>
                    <span>{{$t('reservaSimplificada.verContratoKYC')}}</span>
                  </v-tooltip>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        @click.stop
                        :loading="generando"
                        :disabled="!reserva.contrato"
                        :href="(reserva.contrato && reserva.contrato.documentoSinFirmar ? $contrato(reserva.contrato.documentoSinFirmar.documento.id, true) : '')"
                        target="_blank"
                      >
                      <v-icon   >mdi-eye </v-icon>
                        
                      </v-btn>               
                    </template>
                    <span>{{$t('reservaSimplificada.verContrato') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!contrato">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        :disabled="!reserva.contratoKyc || reserva.estadoKyc.codigoEstadoKyc < 3 || generando || reserva.estadoSincronizacion != null"
                        :loading="generando"
                        @click="borrarContrato(false)"
                      >
                    
                      <v-icon   >mdi-delete-outline </v-icon>
                      </v-btn>                  
                    </template>
                    <span>{{$t('reservaSimplificada.borrarContratoKYC')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>

                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        :disabled="!reserva.contrato || reserva.estadoKyc.codigoEstadoKyc < 3 || generando || reserva.estadoSincronizacion != null"
                        :loading="generando"
                        @click="borrarContrato(false)"
                      >
                      <v-icon   >mdi-delete-outline </v-icon>
                      </v-btn>                  
                    </template>
                    <span>{{$t('reservaSimplificada.borrarContrato')}}</span>
                  </v-tooltip>
                </v-layout>
                
              </div>
            </v-layout>
          </v-container>
        </v-card>
        </v-layout>
        <v-layout  mb-3 justify-center v-if="(!contrato && reserva.contratoKyc) || (contrato && reserva.contrato)">
         
        <label 
          class="theme--light v-label"
        >
          {{$t('reservaSimplificada.adjuntaContratoFirmado')}}
        </label>
      </v-layout>
      <v-layout wrap mb-3 justify-center v-if="(!contrato && reserva.contratoKyc) || (contrato && reserva.contrato)">
        <v-flex 
          xs12 sm12 md8 lg6
          mb-2
        >
          <FileUploader
            style="height:168px"
            :maxNum="1"
            v-model="documento"
            :contrato="true"
            :deletable="reserva.estadoSincronizacion == null"
            :disabled="false"
          />
        </v-flex>
      </v-layout>
      <v-layout v-if="(!contrato && reserva.contratoKyc) || (contrato && reserva.contrato)"
          :column="$vuetify.breakpoint.smAndDown" 
          :shrink="$vuetify.breakpoint.smAndDown"
          justify-center
        >
          <v-btn
            large
            color="primary"
            :disabled="waitingForLoad || !cambiado || reserva.estadoSincronizacion != null"
            :loading="waitingForLoad"
            @click="guardarContrato()"
          >
            {{$t('general.misc.guardar')}}
          </v-btn>
        </v-layout>
      </div>
      <div v-else>
        <v-layout  justify-center mb-3
        >
        <v-card style="width: 50%">
          <v-container fluid>
            <label v-if="reserva.estadoKyc.codigoEstadoKyc < 3"
              class="theme--light v-label"
            >
              {{$t('reservaSimplificada.debeRellenarKyc')}}
            </label>
            <v-layout justify-space-between align-center >
              <h1 v-if="!contrato" class="primary--text">{{$t('reservaSimplificada.firmaContratoKYC')}}</h1>
              <h1 v-else class="primary--text">{{$t('mixins.reserva.contrato')}}</h1>
              <div>
                <v-layout>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                      v-on="on"
                        large :class="(contrato && reserva.contrato != null && reserva.contrato.documentoSinFirmar) || (!contrato && reserva.contratoKyc != null && reserva.contratoKyc.documentoSinFirmar) ? 'green' : 'primary'"
                        icon
                        dark
                        :disabled="reserva.estadoSincronizacion != null || generando || reserva.estadoKyc.codigoEstadoKyc == 1 || (!contrato && reserva.contratoKyc && reserva.contratoKyc.documentoSinFirmar != null) || (contrato && reserva.contrato && reserva.contrato.documentoSinFirmar != null)"
                        :loading="generando"
                        @click="generarContrato()"
                      >
                      <v-icon   style="color: white !important">mdi-file-document </v-icon>
                      </v-btn>

                    </template>
                    <span>{{!contrato ? $t('reservaSimplificada.generarContratoKYC'): $t('reservaSimplificada.generarContrato') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!contrato">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        @click.stop
                        :loading="generando"
                        :disabled="!reserva.contratoKyc || firmando"
                        :href="reserva.contratoKyc && reserva.contratoKyc.documentoFirmado ? $contrato(reserva.contratoKyc.documentoFirmado.documento.id, true) : reserva.contratoKyc && reserva.contratoKyc.documentoSinFirmar ? $contrato(reserva.contratoKyc.documentoSinFirmar.documento.id, true) : ''"
                        target="_blank"
                      >
                      <v-icon   >mdi-eye </v-icon>
                        
                      </v-btn>               
                    </template>
                    <span>{{$t('reservaSimplificada.verContratoKYC')}}</span>
                  </v-tooltip>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        @click.stop
                        :loading="generando"
                        :disabled="!reserva.contrato || firmando"
                        :href="reserva.contrato && reserva.contrato.documentoFirmado ? $contrato(reserva.contrato.documentoFirmado.documento.id, true) : reserva.contrato && reserva.contrato.documentoSinFirmar ? $contrato(reserva.contrato.documentoSinFirmar.documento.id, true) : ''"
                        target="_blank"
                      >
                      <v-icon   >mdi-eye </v-icon>
                        
                      </v-btn>               
                    </template>
                    <span>{{$t('reservaSimplificada.verContrato') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!contrato">
                    
                    <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        :disabled="!reserva.contratoKyc || reserva.estadoKyc.codigoEstadoKyc < 3 || generando || firmando || reserva.estadoSincronizacion != null"
                        :loading="generando"
                        @click="borrarContrato(false)"
                      >
                      <v-icon   >mdi-delete-outline </v-icon>
                      </v-btn>                  
                    </template>
                    <span>{{$t('reservaSimplificada.borrarContratoKYC')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    
                    <template v-slot:activator="{ on }">
                      
                      <v-btn
                        large
                        dark
                        v-on="on"
                        icon
                        class="primary"
                        :disabled="!reserva.contrato || reserva.estadoKyc.codigoEstadoKyc < 3 || generando || firmando || reserva.estadoSincronizacion != null"
                        :loading="generando"
                        @click="borrarContrato(false)"
                      >
                      <v-icon   >mdi-delete-outline </v-icon>
                      </v-btn>                  
                    </template>
                    <span>{{$t('reservaSimplificada.borrarContrato')}}</span>
                  </v-tooltip>
                </v-layout>
                
              </div>
            </v-layout>
          </v-container>
        </v-card>
        </v-layout>
        <v-layout justify-center v-if="!contrato">
          <div class="mb-3" v-if="firmando && !firmaTerminada && reserva.contratoKyc" style="width:100%;">
            <div class="signaturit-div">
              <iframe class="signaturit-iframe" :src="reserva.contratoKyc.url" @load="onIframeLoad"/>
            </div>
          </div>
          <o-main-progress class="elevation-0" :texto="$t('reservaSimplificada.generandoFirma')" v-else-if="generando && !borrando"/>
          <o-main-progress class="elevation-0" :texto="$t('reservas.documentacion.comprobandoFirma')" v-else-if="(firmando && firmaTerminada && !borrando)"/>
        </v-layout>
        <v-layout justify-center v-if="contrato">
          <div class="mb-3" v-if="firmando && !firmaTerminadaContrato && reserva.contrato" style="width:100%;">
            <div class="signaturit-div">
              <iframe class="signaturit-iframe" :src="reserva.contrato.url" @load="onIframeLoad"/>
            </div>
          </div>
          
          <o-main-progress class="elevation-0" :texto="$t('reservaSimplificada.generandoFirma')" v-else-if="generando && !borrando"/>
          <o-main-progress class="elevation-0" :texto="$t('reservas.documentacion.comprobandoFirma')" v-else-if="(firmando && firmaTerminadaContrato && !borrando)"/>
        </v-layout>
      </div>
      
    </v-container>
    <v-fade-transition>
        <custom-dialog v-if="mostrarComprobarEmail" v-model="mostrarComprobarEmail">
          <ComprobarEmailTelefono
            :compradores="compradores"
            @aceptar="cambiarEmailTelefono"
          />
        </custom-dialog>
      </v-fade-transition>
    <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarBorrarContrato"
        @aceptar="$event ? borrarContrato(true) : mostrarBorrarContrato = false"
        :titulo="!contrato ? $t('reservaSimplificada.borrarContratoKYC') :$t('reservaSimplificada.borrarContrato')"
        :alerta="$t('general.popUpSeguro.alertaIrreversible')"
        :pregunta="contrato ? $t('reservaSimplificada.borrarContratoConfirmar') : $t('reservaSimplificada.borrarContratoConfirmarKYC')"
        :valorCheck.sync="borrarAmbos"
        :mostrarCheck="contrato  && reserva.contratoKyc != null"
        :textoCheck="$t('reservaSimplificada.borrarAmbosContratos')"
        :descartar="$t('general.misc.eliminar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
    <v-fade-transition>
        <custom-dialog 
          v-if="(esAdministrador || esComercial) && mostrarPopUpFirmantes" 
          v-model="mostrarPopUpFirmantes"
          :cambiado="false"
          @aceptar="mostrarPopUpFirmantes = false"
        >
          <ContratoElegirFirmantes
            :representantes.sync="representantes"
            :plantilla.sync="plantilla"
            :otp.sync="otp"
            :ocultar="getActual.modalidadFirma != 1"
            :tipo.sync="tipo"
            @cambiado="cambiadoFirma = $event"
            @aceptar="generarContrato(true, true)"
          />
        </custom-dialog>
      </v-fade-transition>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import PopUpSeguro from '@/components/generic/PopUpSeguro'
import FileUploader from '@/components/generic/fileUploader/FileUploader'
import _ from 'lodash'
import MixinComprador from '@/mixins/comprador'
import ComprobarEmailTelefono from '@/components/reservas/comprador/ComprobarEmailTelefono'
import ContratoElegirFirmantes from '@/components/reservas/contratos/ContratoElegirFirmantes'
import rules from '@/mixins/rules'


export default {
  mixins: [rules, MixinComprador],
  props: {
    contrato: {
      default: false,
      type: Boolean
    },
    active: {
    }
  },
  data () {
    return {
      documento: [],
      borrarAmbos: false,
      mostrarBorrarContrato: false,
      generando: false,
      borrando: false,
      representantes: [],
      plantilla: null,
      otp: false,
      tipo: 'url',
      inicializado: false,
      firmando: false,
      compradores: [],
      waitingForLoad: false,
      numeroFirmas: null,
      firmaTerminada: false,
      firmaTerminadaContrato: false,
      cambiadoData: false,
      mostrarComprobarEmail: false,
      mostrarPopUpFirmantes: false
    }
  },
  components: {
    FileUploader, PopUpSeguro, ContratoElegirFirmantes, ComprobarEmailTelefono
  },
  async created () {
    window.addEventListener('message', this.completedEvent)
    this.inicializarCompradores()
    this.firmaTerminada = this.getActual.modalidadFirma == 1 && this.reserva.estadoKyc.codigoEstadoKyc == 10 && this.reserva.contratoKyc && this.reserva.contratoKyc.documentoFirmado &&  this.reserva.contratoKyc.documentoFirmado.documento
    this.firmaTerminadaContrato = this.getActual.modalidadFirma == 1 && this.reserva.estadoContrato.codigoEstadoContrato == 10 && this.reserva.contrato && this.reserva.contrato.documentoFirmado &&  this.reserva.contrato.documentoFirmado.documento
    if (this.getActual.modalidadFirma != 1) {
      if (this.contrato) {
        if (this.reserva.contrato && this.reserva.contrato.documentoFirmado) {
          this.documento.push( this.reserva.contrato.documentoFirmado.documento)
        }
      } else {
        if (this.reserva.contratoKyc && this.reserva.contratoKyc.documentoFirmado) {
          this.documento.push( this.reserva.contratoKyc.documentoFirmado.documento)
        }
      }
      
    }
    if (this.contrato) {
      this.representantes = this.getAllRepresentantes.filter(x => x.esPorDefecto)
      let checkPlantilla = this.getPromocionPlantillas.filter(x => x.ambito === this.reserva.cod_tipo_operacion).find(x => x.esPorDefecto)
      if (checkPlantilla == null) {
        this.plantilla = null
      } else {
        this.plantilla = checkPlantilla.plantilla.id
      }
      this.otp = this.otpActivado
      this.tipo = this.representantes.some(x => x.representante.documento_id == null) ? 'email' : 'url'
    }
    await this.$nextTick()
    this.inicializado = true

  },
  computed: {
    ...mapGetters({
      getActual: 'modulosOrdenes/getActual',
      reserva: 'reservas/_id/getActual',
      refreshDocu: 'reservas/_id/getRefreshDocu',
      getAllRepresentantes: 'promocionesRepresentantes/getAll',
      getVariableConfiguracion: 'configuracion/variablesConfiguracion/getById',
      getPromocionPlantillas: 'promocionesPlantillas/getAll'
    }),
    otpActivado () {
      return this.getVariableConfiguracion('VD_OTP_ACTIVADO') && this.getVariableConfiguracion('VD_OTP_ACTIVADO').valor === 'S'
    },
    cambiado () {
      return this.cambiadoData
    }
  },
  methods: {
    onIframeLoad() {
      this.generando = false
    },
    ...mapActions({
      addAlert: 'alerts/add',
      firmarContratoKyc: 'documentacion/firmarContratoKyc',
      loadReserva: 'reservas/_id/load',
      setRefreshDocu: 'reservas/_id/setRefreshDocu',
      firmarContrato: 'contratos/firmar',
      modificarCompradoresContrato: 'contratos/modificar',
      generarContratoBack: 'reservas/_id/generarContrato',
      borrarContratoBack: 'reservas/_id/borrarContrato',
      loadAllCompradores: 'compradores/loadAll',
      guardarContratoBack: 'reservas/_id/guardarContrato'
    }),
    cambiarEmailTelefono (compradores) {
      for(let i = 0; i < compradores.length; i++) {
        this.compradores[i].email = compradores[i].email
        this.compradores[i].numTelefono = compradores[i].numTelefono
        this.compradores[i].telefono = compradores[i].telefono
        this.compradores[i].codigoPrefijoTelefonicoId = compradores[i].codigoPrefijoTelefonicoId
      }
      this.mostrarComprobarEmail = false
      this.generarContrato(true, false)
    },
    async completedEvent (e) {
      if (this.active ==2 && !this.contrato) {
        try {
          if (e.data.event === 'completed') {
            this.numeroFirmas = this.reserva.contratoKyc.firmantes.length
            if (this.numeroFirmas === this.reserva.contratoKyc.firmantes.length) {
              this.firmaTerminada = true
              await this.firmarContratoKyc({id: this.reserva.id, simplificada: true})
              this.firmando = false
              this.addAlert({texto: this.$t('reservaSimplificada.KYCFirmado'), color: 'success'})
            }
          }
        } catch (error) {
          if (error.code && Number(error.code) === 16) { // PETO LA FIRMA
            this.firmaTerminadaContrato = true
            this.firmando = false
          } else {
            this.addAlert({texto: error.message, color: 'error'})
            this.$emit('error')
          }
        }
      } else if (this.active != 2 && this.contrato) {
        try {
          if (e.data.event === 'completed') {
            this.numeroFirmas = this.reserva.contrato.firmantes.length
            if (this.numeroFirmas === this.reserva.contrato.firmantes.length) {
              this.firmaTerminadaContrato = true
              await this.firmarContrato({id: this.reserva.id, simplificada: true})
              this.firmando = false
              this.addAlert({texto: this.$t('reservaSimplificada.contratoFirmado'), color: 'success'})
            }
          }
        } catch (error) {
          console.log(error)
          if (error.code && Number(error.code) === 16) { // PETO LA FIRMA
            this.firmaTerminadaContrato = true
            this.firmando = false
          } else {
            this.addAlert({texto: error.message, color: 'error'})
            this.$emit('error')
          }
        }
      } 
    },
    async generarContrato (comprobado = false, vengoDePopUp = false) {
      if (!comprobado && this.getActual.modalidadFirma == 1) {
        this.mostrarComprobarEmail = true
        return
      }
      if (!vengoDePopUp && this.contrato) {
        this.mostrarPopUpFirmantes = true
        return
      } else {
        this.mostrarPopUpFirmantes = false
        }
      if (!this.contrato) {
        try {
          this.generando = true
          await this.generarContratoBack({id_reserva: this.reserva.id, modalidadFirma: this.getActual.modalidadFirma, compradores: _.concat(this.compradores.filter(x => x.id == null), _.concat(_.uniqBy(this.compradores.filter(x => x.id != null), 'id')))})
          this.addAlert({texto: this.$t('reservaSimplificada.KYCGenerado'), color: 'success'})
          this.generando = false
          this.firmando = true
        } catch (error) {
          this.addAlert({texto: error.message, color: 'error'})
          this.generando = false
        }  
      } else {
        try {
          this.generando = true
          await this.modificarCompradoresContrato({
            id: this.reserva.id,
            compradores: _.concat(this.compradores.filter(x => x.id == null), _.concat(_.uniqBy(this.compradores.filter(x => x.id != null), 'id'))),
            completado: true,
            representantes: this.representantes.map(x => ({id: x.id, tipoDocumento: x.representante.tipoDocumento, numeroDocumento: x.representante.numeroDocumento})),
            plantilla: this.plantilla,
            otp: this.otp,
            tipo: this.tipo
          })
          this.addAlert({texto: this.$t('reservaSimplificada.contratoGenerado'), color: 'success'})
          this.generando = false
          this.firmando = true
        } catch (error) {
          this.addAlert({texto: error.message, color: 'error'})
          this.generando = false
          this.firmando = false
        }  
      }
      await this.loadAllCompradores(this.reserva.id)
      this.inicializarCompradores()
    },
    async borrarContrato (confirmado) {
      try {
        if (!confirmado) {
          this.borrarAmbos = false
          this.mostrarBorrarContrato = true
          return
        }
        this.mostrarBorrarContrato = false
        this.borrando = true
        this.generando = true
        await this.borrarContratoBack({id: this.reserva.id, kyc: !this.contrato, borrarAmbos: this.borrarAmbos})
        if (this.contrato) {
          this.addAlert({texto: this.$t('reservaSimplificada.contratoBorrado'), color: 'success'})
          if (this.borrarAmbos) {
            this.setRefreshDocu(true)
          }
        } else {
          this.addAlert({texto: this.$t('reservaSimplificada.KYCBorrado'), color: 'success'})
          this.setRefreshDocu(true)
        }
        
        this.generando = false
        if (this.contrato) {
          this.firmaTerminadaContrato = false
        } else {
          this.firmaTerminada = false
        }
        this.compradores = []
        this.inicializarCompradores()
        this.borrando = false
        this.documento = []
        this.firmando = true
      } catch (error) {
        this.addAlert({texto: error.message, color: 'error'})
        this.generando = false
        this.borrando = false
        this.compradores = []
        this.inicializarCompradores()
      }      
    },
    async guardarContrato () {
      try {
        this.waitingForLoad = true
        await this.guardarContratoBack({id: this.reserva.id, kyc: !this.contrato,
          documento: this.documento[0]})
        await this.loadReserva(this.reserva.id)
        if (this.contrato) {
          this.addAlert({texto: this.$t('reservaSimplificada.contratoFirmado'), color: 'success'})
        } else {
          this.addAlert({texto: this.$t('reservaSimplificada.KYCFirmado'), color: 'success'})
        }
       
        this.waitingForLoad = false
        this.cambiadoData = false
      } catch (error) {
        this.addAlert({texto: error.message, color: 'error'})
        this.waitingForLoad = false
      }      
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.completedEvent)
  },
  watch: {
    documento () {
      if (this.inicializado) {
        this.cambiadoData = true
      }
    },

    async refreshDocu (newValue) {
      if (newValue) {
        this.documento = []
        await this.$nextTick()
        this.setRefreshDocu(false)
      }
    },
    async active () {
      this.compradores = []
      this.inicializarCompradores()
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/kyc/FirmaSimplificada.vue